<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/UCx10R/tc-custom/9781250024572.jpg?1739474634125" alt="This image is the cover for the book Bug"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bug
      </h1>
      <p class="bookDescription body article font2">
        <p>With a New Introduction by Mary Gaitskill <br/><br/>A PEN/Hemingway Award Finalist <br/><br/>A <i>New York Times Book Review</i> Notable Book <br/><br/>Ellen Ullman is a "rarity, a computer programmer with a poet's feeling for language" (Laura Miller, <i>Salon</i>). <i>The Bug</i> breaks new ground in literary fiction, offering us a deep look into the internal lives of people in the technical world. Set in a start-up company in 1984, this highly acclaimed first novel explores what happens when a baffling software flaw—a bug so teasing it is named "the Jester"—threatens the survival of the human beings who created it.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ellen Ullman, Mary Gaitskill
      </h2>
      
      <p class="authorDescription body article"><P><B>Ellen Ullman</B> is an American computer programmer and author. She has written novels as well as articles for various publications, including <I>Harper's Magazine</I>, <I>Wired</I>, <I>The New York Times</I>, and <I>Salon</I>. Her essays and novels analyze the human side of the world of computer programming. Ullman earned a bachelor's degree  in English at Cornell University in the early 1970s. She then turned to business programming in the following years. She eventually began writing about her experiences as a programmer in 1995 when she wrote an essay titled "Out of Time: Reflections on the Programming Life." She lives in San Francisco.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?198e3481